/**
 * Handles authentication failures by detecting either:
 * 1. Server redirects to login pages (HTML responses to API calls)
 * 2. Standard 401 Unauthorized responses
 *
 * In both cases, forces a full page reload to restart the auth flow.
 *
 * @param response - The axios response object
 * @throws Error if server redirected to login page
 */
export const handleAuthenticationFailure = (response: any) => {
  // Check if server redirected API request to login page (HTML response)
  const isHtmlResponse = response.headers?.["content-type"]?.includes?.("text/html");

  if (isHtmlResponse) {
    const { pathname } = response.request.responseURL ? new URL(response.request.responseURL) : { pathname: "" };

    if (pathname.startsWith("/authn/")) {
      window.location.reload();
      throw new Error("Server redirected API request to login page, most likely due to expired session");
    }
  }

  // Handle standard 401 Unauthorized responses
  if (response.status === 401) {
    window.location.reload();
  }
};
